var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCloseRound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2605_4195)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11 1.375C5.6375 1.375 1.375 5.6375 1.375 11C1.375 16.3625 5.6375 20.625 11 20.625C16.3625 20.625 20.625 16.3625 20.625 11C20.625 5.6375 16.3625 1.375 11 1.375ZM11 19.25C6.4625 19.25 2.75 15.5375 2.75 11C2.75 6.4625 6.4625 2.75 11 2.75C15.5375 2.75 19.25 6.4625 19.25 11C19.25 15.5375 15.5375 19.25 11 19.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7125 15.8125L11 12.1L7.2875 15.8125L6.1875 14.7125L9.9 11L6.1875 7.2875L7.2875 6.1875L11 9.9L14.7125 6.1875L15.8125 7.2875L12.1 11L15.8125 14.7125L14.7125 15.8125Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2605_4195"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseRound);
export default __webpack_public_path__ + "static/media/close_round.0b9134e217f82943872c8d2c24bf5ba8.svg";
export { ForwardRef as ReactComponent };